import { confirmAlert } from "react-confirm-alert"
import {
  getTermsAgreementCookie,
  setTermsAgreementCookie,
} from "src/utils/auth/userCookies"
import URLUtils from "src/utils/URLUtils"

const useLoginConfirm = () => {
  const loginConfirm = (login: () => Promise<void>) => {
    if (
      getTermsAgreementCookie() &&
      getTermsAgreementCookie().toLowerCase() === "true"
    ) {
      login()

      return
    }

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <>
            <div className="p-modal modal-primary js-modal">
              <div className="p-modal-inner">
                <div className="p-modal-contents">
                  <div className="p-modal-contents-inner">
                    <button
                      className="c-close-button p-modal-close js-modal-close"
                      onClick={async () => {
                        onClose()
                      }}
                    >
                      <span className="c-close-button-icon"></span>
                      <span className="c-close-button-label">閉じる</span>
                    </button>
                    <div className="modal-primary-body">
                      <div className="modal-primary-body-inner">
                        <p>
                          当サービスのご利用につきましては、以下利用条件及び個人情報の取り扱いに同意ください。
                        </p>
                        <p className="center">
                          <a
                            href={`${URLUtils.getHelpPage("terms/index.html")}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            「利用規約」
                          </a>
                          及び
                          <a
                            href={`${URLUtils.getHelpPage(
                              "personalinfo/index.html",
                            )}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            「個人情報のお取り扱い」
                          </a>
                          に同意する
                        </p>
                      </div>
                    </div>
                    <div className="p-modal-footer">
                      <div className="p-modal-action -plate">
                        <div className="p-modal-action-col">
                          <button
                            className="p-modal-action-cancel c-button-secondary -outline -full confirm-button"
                            onClick={() => {
                              setTermsAgreementCookie()
                              onClose()
                              login()
                            }}
                          >
                            はい
                          </button>
                        </div>
                        <div className="p-modal-action-col -plate">
                          <button
                            onClick={() => {
                              onClose()
                            }}
                            className="p-modal-action-submit c-button-secondary -full"
                          >
                            いいえ
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-modal-overlay js-modal-overlay"></div>
          </>
        )
      },
    })
  }

  return {
    loginConfirm,
  }
}

export { useLoginConfirm }
